import {Component, OnInit, Input} from '@angular/core';
import {WebsocketService} from "../../../services/websocket/websocket.service";


@Component({
    selector: 'app-websocket-client',
    templateUrl: './websocket-client.component.html',
    styleUrls: ['./websocket-client.component.css'],
    standalone: false
})
export class WebsocketClientComponent implements OnInit {

  public webSocket: WebsocketService
  @Input()
  url: string | undefined;
  text = '';

  constructor(private websocketService: WebsocketService) {
    this.webSocket = websocketService;
  }

  ngOnInit(): void {
  }

  sendMessage() {
    this.webSocket.sendWebSocketMessage(this.text);
    // wsMessageForm.controls.reset();
  }

  open() {
    if (this.url != undefined)
      this.webSocket.openWebSocketConnection(this.url);
  }

  close() {
    this.webSocket.closeWebSocketConnection();
  }
}
